import React, { useEffect, useRef } from 'react';
import IconChevronRight from '../Icons/IconChevronRight';
import { ScrollerContent, ScrollIcon, Shadow } from './Scroller.styles';

export const LongContent = ({ scrollLeftTo, handleSetScroll, children }) => {
    const elRef = useRef(null);

    useEffect(() => {
        if (elRef.current) {
            elRef.current.scrollLeft = scrollLeftTo;
        }
    }, [scrollLeftTo]);

    const getCurrentPosAndScroll = () => {
        const currentScrollPos = elRef.current.scrollLeft;
        const scrollIncrement = 300;
        handleSetScroll(currentScrollPos + scrollIncrement);
    };

    return (
        <ScrollerContent ref={elRef}>
            <ScrollIcon onClick={getCurrentPosAndScroll}>
                <IconChevronRight />
            </ScrollIcon>
            <Shadow />
            {children}
        </ScrollerContent>
    );
};
